import React from 'react';
import PageTemplate from '@/components/ui/PageTemplate';
import { BuildingTrustContent } from './company/BuildingTrust';
import { ConjunctionBriefingContent } from './company/ConjunctionBriefing';
import { VIDEO_URLS } from '@/constants/videos';

const CombinedHomePage = () => {
  return (
    <PageTemplate id='Combined-Home'>
      {/* Mobile Video */}
      <div className='md:hidden absolute top-[-190px] left-0 w-full h-[60vh] z-0'>
        {/* <video
          className='w-full h-full object-cover pointer-events-none'
          muted
          autoPlay
          loop
          playsInline
        >
          <source src={VIDEO_URLS.LANDING_PAGE} />
        </video> */}
        <div className='absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/100'></div>
      </div>

      {/* Desktop Video */}
      <div className='hidden md:block absolute top-[-450px] left-0 w-full h-[150vh] z-0'>
        {/* <video
          className='w-full h-full object-cover pointer-events-none'
          muted
          autoPlay
          loop
          playsInline
        >
          <source src={VIDEO_URLS.LANDING_PAGE} />
        </video> */}
        <div className='absolute inset-0'></div>
      </div>
      <div
        className='absolute left-0 w-full z-0 bg-cover bg-center bg-no-repeat'
        style={{
          backgroundImage: "url('/redesign/BG_Vision.png')",
          top: '50vh',
          bottom: 0,
        }}
      ></div>

      <div className='relative z-10'>
        {/* <section id='Home' className='min-h-screen'>
          <HomeContent />
        </section> */}
        <section id='Conjunction Briefing' className='min-h-screen'>
          <ConjunctionBriefingContent />
        </section>
        <section id='Building Trust' className='min-h-screen'>
          <BuildingTrustContent />
        </section>
      </div>
    </PageTemplate>
  );
};

export default React.memo(CombinedHomePage);
